import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import Problem from "../components/Problem";
import HowItWorks from "../components/HowItWorks";
import Services from "../components/Services";
import About from "../components/About";
import ClosingCTA from "../components/ClosingCTA";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import { useLang } from "../i18n";

export default function Home() {
  const { lang, t } = useLang();
  return (
    <div className="bg-crema">
      <SEO title={t.seo.title} description={t.seo.desc} path="/" lang={lang} />
      <Header />
      <main>
        <Hero />
        <Problem />
        <HowItWorks />
        <Services />
        <About />
        <ClosingCTA />
      </main>
      <Footer />
    </div>
  );
}
